
import Vue from 'vue'
import Newsletter from './newsletter'
export default Vue.extend({
    props: {
        newsletter: Object as () => Newsletter
    }
})
